import { instance } from './ajax.js'

export const MachineApi = {
    facility(params) { // 设备
        return instance.get('vendingApi/facilityInfoQuery', { params })
    },
    goodsInfoById(params) { // 商品信息
        return instance.get('vendingApi/trackInfo/' + params.id)
    },
    selectGoodsInfoByFacilityId(params) { // 设备
        return instance.get('/prod-api/api/outFacility/selectGoodsInfoByFacilityId', { params })
    },
}

export const OrderApi = {
    shoppingCar(params) {
        return instance.post('vendingApi/shoppingCar',  params)
    },
    goodsOrderInfo(params) {
        return instance.get('vendingApi/goodsOrderInfo/' + params.id)
    },
    goods_order(params) {
        return instance.get('vendingApi/goods_order/' + params.id)
    }
}

export const ConfigApi = {
    // prod-api/api/getoOenid/getApiGetopenid
    getApiGetopenid(params) {
        return instance.get('/prod-api/api/getoOenid/getApiGetopenid', { params })
    },
}

export const PayApi= {
    // pullPay
    pullPay(data) {
        return instance.post('/prod-api/api/pay/pullPay', data)
    },
    //用户汇付支付
    pullHuifuPay(data) {
        return instance.post('/prod-api/api/huifu/pay/pullPay', data)
    },
    getUserId(data) {
        return instance.get('/prod-api/api/alipay/getUserId', { params: data })
    },
    checkStock(data) {
        return instance.get('/prod-api/api/pay/checkStock', { params: data })
    }
}
